// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT TOUCH :) */

ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

a {
    text-decoration: none;
    color: inherit;
}

/* Header styling */
header {
    top: 0px;
    background-color: #6b6960; 
    width: 100%;
    z-index: 1500;
}

/* Navbar styling */
.navbar {
    max-width: 65rem;
    padding: 0 2rem;
    margin: 0 auto;
    display: flex;
    align-items: center; 
}

.navbar-links ul {
    display: flex;
    gap: 1.2rem;
    font-weight: 800;
    font-family: "Ubuntu", sans-serif;
    font-size: 1.1rem;
}

.navbar-links li {
    display: inline;
}

.navbar-links .nav-link {
    color: white;
    padding: 8px 6px;
    border-radius: 4px;
}

.navbar-links .nav-link:hover,
.navbar-links .active-link {
    text-decoration: underline;
    font-weight: bold;
}

.logo-container {
    display: flex;
    align-items: center;
    font-family: "Rubik Wet Paint", system-ui;
    font-optical-sizing: auto;
    font-style: normal;
    text-shadow: 0 0 4px black;
}

.logo {
    font-size: 2rem;
    font-weight: 1000;
    letter-spacing: 2px;
    line-height: 5rem;
    margin-right: 10rem;     
    align-items: center;
}

.logo img {
    height: 75px;
    width: auto;
    margin-left: 10px;
    margin-top: 10px;
    object-fit: contain;
    border-radius: 0; 
}

.rotating {
    animation: rotate 1s infinite alternate; 
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(-20deg);
    }
    100% {
        transform: rotate(20deg);
    }
}

.logo-scale {
    transform: scale(1.15);
    transition: transform 0.5s ease;
}

.nav-link-scale {
    transform: scale(1.1); 
    transition: transform 0.5s ease; 
}
`, "",{"version":3,"sources":["webpack://./src/components/navbar.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,QAAQ;IACR,yBAAyB;IACzB,WAAW;IACX,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC","sourcesContent":["/* DO NOT TOUCH :) */\n\nul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\n/* Header styling */\nheader {\n    top: 0px;\n    background-color: #6b6960; \n    width: 100%;\n    z-index: 1500;\n}\n\n/* Navbar styling */\n.navbar {\n    max-width: 65rem;\n    padding: 0 2rem;\n    margin: 0 auto;\n    display: flex;\n    align-items: center; \n}\n\n.navbar-links ul {\n    display: flex;\n    gap: 1.2rem;\n    font-weight: 800;\n    font-family: \"Ubuntu\", sans-serif;\n    font-size: 1.1rem;\n}\n\n.navbar-links li {\n    display: inline;\n}\n\n.navbar-links .nav-link {\n    color: white;\n    padding: 8px 6px;\n    border-radius: 4px;\n}\n\n.navbar-links .nav-link:hover,\n.navbar-links .active-link {\n    text-decoration: underline;\n    font-weight: bold;\n}\n\n.logo-container {\n    display: flex;\n    align-items: center;\n    font-family: \"Rubik Wet Paint\", system-ui;\n    font-optical-sizing: auto;\n    font-style: normal;\n    text-shadow: 0 0 4px black;\n}\n\n.logo {\n    font-size: 2rem;\n    font-weight: 1000;\n    letter-spacing: 2px;\n    line-height: 5rem;\n    margin-right: 10rem;     \n    align-items: center;\n}\n\n.logo img {\n    height: 75px;\n    width: auto;\n    margin-left: 10px;\n    margin-top: 10px;\n    object-fit: contain;\n    border-radius: 0; \n}\n\n.rotating {\n    animation: rotate 1s infinite alternate; \n}\n\n@keyframes rotate {\n    0% {\n        transform: rotate(0deg);\n    }\n    50% {\n        transform: rotate(-20deg);\n    }\n    100% {\n        transform: rotate(20deg);\n    }\n}\n\n.logo-scale {\n    transform: scale(1.15);\n    transition: transform 0.5s ease;\n}\n\n.nav-link-scale {\n    transform: scale(1.1); \n    transition: transform 0.5s ease; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
